import { render, staticRenderFns } from "./ProjectsRegister.vue?vue&type=template&id=d637aab4&scoped=true"
import script from "./ProjectsRegister.vue?vue&type=script&lang=js"
export * from "./ProjectsRegister.vue?vue&type=script&lang=js"
import style0 from "./ProjectsRegister.vue?vue&type=style&index=0&id=d637aab4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d637aab4",
  null
  
)

export default component.exports